export const navLinks = [
    {
        name: "Home",
        link: "/"
    },
    {
        name: "Resume",
        link: "/Resume"
    },
    {
        name: "Work",
        link: "/Work"
    },
    {
        name: "Contact",
        link: "/Contact"
    }
]